var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container"},[_c('svg',{ref:"tree",attrs:{"height":_vm.height,"width":_vm.width}},[_c('g',{ref:"main",staticClass:"main",attrs:{"transform":`translate(${_vm.padding[3]}, ${_vm.padding[0]})`}})]),_c('div',{ref:"tooltip"})])
}
var staticRenderFns = []

export { render, staticRenderFns }